// Register the Service Worker for PWA installability + seamless updates.
export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.hostname === "localhost") return;

  // When a new SW takes control (after a deploy), reload once to load fresh code.
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Check for updates when the app comes back to foreground (typical PWA usage).
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") reg.update().catch(() => {});
        });
      })
      .catch((err) => console.warn("[SW] register failed:", err));
  });
}
